import { render, staticRenderFns } from "./CurrentTag.vue?vue&type=template&id=ca3d5aa4&scoped=true&"
import script from "./CurrentTag.vue?vue&type=script&lang=js&"
export * from "./CurrentTag.vue?vue&type=script&lang=js&"
import style0 from "./CurrentTag.vue?vue&type=style&index=0&id=ca3d5aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3d5aa4",
  null
  
)

component.options.__file = "CurrentTag.vue"
export default component.exports